<script lang="ts">
    export let formInputType: "phone" | "email";
    export let shopName: string;
</script>

<span class="my-1 text-center text-xs">
    By submitting this form, you agree to receive recurring automated
    promotional and personalized marketing {formInputType === "phone"
        ? "text messages"
        : "emails"} (e.g. cart reminders) from {shopName} at the {formInputType ===
    "phone"
        ? "cell number"
        : "email address"} used when signing up. Consent is not a condition of any
    purchase. {#if formInputType === "phone"}Reply HELP for help and STOP to
        cancel. Msg frequency varies. Msg & data rates may apply.{/if} View
    <a target="_blank" href="https://attnl.tv/t/m1s/r/US" class="underline"
        >Terms</a
    >
    &
    <a target="_blank" href="https://attnl.tv/p/m1s" class="underline"
        >Privacy</a
    >.
</span>
